var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenuSale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.975 0H1.97498C1.70976 0 1.45541 0.105357 1.26787 0.292893C1.08033 0.48043 0.974976 0.734784 0.974976 1V19C0.974976 19.2652 1.08033 19.5196 1.26787 19.7071C1.45541 19.8946 1.70976 20 1.97498 20H10.475V15C10.475 13.622 11.597 12.5 12.975 12.5H17.975V1C17.975 0.734784 17.8696 0.48043 17.6821 0.292893C17.4945 0.105357 17.2402 0 16.975 0Z",
    fill: "#DBDCDF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.975 15V20L17.975 14H12.975C12.7098 14 12.4554 14.1054 12.2679 14.2929C12.0803 14.4804 11.975 14.7348 11.975 15Z",
    fill: "#DBDCDF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuSale);
export default __webpack_public_path__ + "static/media/icon_menu_sale.063b113fc0ad0bbe91d15c3fe81d984a.svg";
export { ForwardRef as ReactComponent };